const AMENITY_ICON_NAMES: Record<string, string> = {
  carparking: "CarParkingIcon",
  swimming: "SwimmingIcon",
  gymfit: "GymFitIcon",
  restaurant: "RestaurantIcon",
  wifi: "WifiIcon",
  petcenter: "PetCenterIcon",
  sportsclub: "SportsClubIcon",
  laundry: "LaundryIcon",
  powerbackup: "PowerBackupIcon",
  centralac: "CentralACIcon",
  "247security": "Security24Icon",
  watersupply: "WaterSupplyIcon",
  sewageplant: "SewagePlantIcon",
  rainwaterharvesting: "RainwaterHarvestingIcon",
  solarpowerusage: "SolarPowerIcon",
  solarpower: "SolarPowerIcon",
  evcharginginfra: "EvChargingIcon",
  evcharging: "EvChargingIcon",
  highspeedelevators: "HighSpeedElevatorIcon",
  highspeedelevator: "HighSpeedElevatorIcon",
  firesafetysystem: "FireSafetyIcon",
  firesafety: "FireSafetyIcon",
  ampleparkingspace: "AmpleParkingIcon",
  ampleparking: "AmpleParkingIcon",
  conferencerooms: "ConferenceRoomIcon",
  conferenceroom: "ConferenceRoomIcon",
};

export const normalizeAmenityKey = (uiFieldName: string) =>
  String(uiFieldName || "")
    .toLowerCase()
    .replace(/&/g, "")
    .replace(/[^a-z0-9]/g, "");

export const getAmenityIconName = (uiFieldName: string) =>
  AMENITY_ICON_NAMES[normalizeAmenityKey(uiFieldName)] || "InfoIcon";
